import { React, useEffect, useReducer, useState } from 'react';

import { Content } from 'antd/es/layout/layout';
import { useNavigate } from 'react-router-dom';
import { Row, Col,Typography, Space, Tooltip, Select, Empty, message } from 'antd';
import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useAuth } from '../Context';
import { ApartmentOutlined} from '@ant-design/icons';
import { Background, Controls, Handle, Position, ReactFlow } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import axios from 'axios';
import {  PROJECT_TREE_ERROR, PROJECT_TREE_SUCCESS } from './constants';
import projectTreeReducer from './reducer';
const { Title } = Typography;



export default function Tree() {
	/* eslint-disable react/prop-types */
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	useAuth();
	// const [form] = Form.useForm();	
	// const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	// const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const pipelineName = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_PIPELINE_NAME`)).toUpperCase();

	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const admin_roles = ['superadmin','admin'];
	const {regiondata, getRegion,  pidsRegionData, getPidsRegion,channelData, getChannels} = useAuth();
	const navigate = useNavigate();
	const [regionId, setRegionId] = useState(localStorage.getItem(`${dashboardtype.toUpperCase()}_REPORT_REGION_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_REPORT_REGION_ID`)) : null);
	const [pidsFilter, setpidsFilter] = useState(localStorage.getItem(`${dashboardtype.toUpperCase()}_REPORT_PIDS`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_REPORT_PIDS`)) : null);
	const [channelsdata, setchannels] = useState(localStorage.getItem(`${dashboardtype.toUpperCase()}_REPORT_CHANNEL_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_REPORT_CHANNEL_ID`)) : null);
	const initalState = {multi : [], multiple : [], single : [], multimod : '',datasource : '' ,  details: null, pending: false, error: false , datagentype: [],modelClassificationDate: [], modeltype: [] , imageclassification : [], imageclassificationenabled : false};
	const [data, dispatch] = useReducer(projectTreeReducer, initalState);

	let regions=[];
	let pidsfilter=[];
	let channels=[];
	let predy = 1800;

	const onNodeClick = (event, node) => {
		if (node.data?.route) {
			navigate(node.data.route);
		}
	};

	const loadTreeData = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/projecttreeapi?regioninfoId=${regionId}&pidsinfoId=${pidsFilter}&channelinfoId=${channelsdata}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:PROJECT_TREE_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:PROJECT_TREE_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};
	
	useEffect(() => {
		if(featuresModule.modelTypeEnabled == false) {
			navigate('/dashboard');
		}
		if(!authtoken){
			navigate('/');
		}

		getRegion(authtoken);

		if(regionId!=null){
			getPidsRegion(authtoken,regionId);
		}

		if(pidsFilter!=null){
			getChannels(authtoken, pidsFilter);

		}

		if(regionId != null && channelsdata != null && pidsFilter != null){
			loadTreeData();
		}
		
	
	},[authtoken,regionId,pidsFilter,channelsdata]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4028);

	}, []);

	

	const baseNodeStyle = {
		borderRadius: '50px',
		padding: '10px 25px',
		width: '250px',
		textAlign: 'center',
		fontWeight: 900,
		backgroundColor: '#1890ff',
		color: '#fff',
		cursor: 'pointer'
	};

	if(admin_roles.includes(permission)){
		regiondata && regiondata.map((region)=>{
			regions.push({
				value:region.id,
				label:region.regionName.toUpperCase()});
		});
	}

	pidsRegionData && pidsRegionData.map((pid)=>{
		pidsfilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});


	channelData && channelData.map((item) => {
		channels.push({
			value : item.id,
			label : item.name,
		});
	});


	const regionLabel = regions.find(item => regionId == item.value)?.label;
	const pidslabel = pidsfilter.find((item) => pidsFilter == item.value)?.label;
	const channelLabel = channels.find((item) => channelsdata == item.value)?.label;




	const nodes = [
		{
			id: '1',
			position: { x: 250, y: 0 },
			data: { label: 'Pipeline', pipeline : pipelineName ? pipelineName : pipelineId,   route : '/chainage-filter' },
			draggable: false,
			style: baseNodeStyle,
			type : 'hoverNode'
		},
		{
			id: '2',
			position: { x: 250, y: 75 },
			data: { label: 'Region', region : regionLabel,  route : '/region-management' },
			draggable: false,
			style: baseNodeStyle,
			type : 'hoverNode'
		},
		{
			id: '3',
			position: { x: 250, y: 150 },
			data: { label: 'PIDS', pidsname : pidslabel, route : '/pidsmanagement'},
			draggable: false,
			style: baseNodeStyle,
			type : 'hoverNode'
		},
		{
			id: '4',
			position: { x: 250, y: 225 },
			data: { label: 'Channel', channel : channelLabel, route : '/channel-info'},
			draggable: false,
			style: baseNodeStyle,
			type : 'hoverNode'
		},
		{
			id: '5',
			position: { x: 250, y: 375 },
			data: { label: 'Model Type',route : '/modeltype' },
			draggable: false,
			style: baseNodeStyle
		},
		{
			id: '6',
			position: { x: 250, y: 450 },
			data: { label: 'Prediction Level',route : '/prediction-level'},
			draggable: false,
			style: baseNodeStyle
		},
		{
			id: '7',
			position: { x: -250, y: 600 },
			data: { label: 'single'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'single' ? 'gray' : '#1890ff'
			}
		},
		{
			id: '8',
			position: { x: 250, y: 600 },
			data: { label: 'multiple'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
			}
		},
		{
			id: '9',
			position: { x: 750, y: 600 },
			data: { label: 'multi'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multi' ? 'gray' : '#1890ff'
			}
		},
		{
			id: '10',
			position: { x: -250, y: 700 },
			data: { label: 'Model Classification',route : '/model-classification-config'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'single' ? 'gray' : '#1890ff'
			},
			sourcePosition: 'left' 
		},
		{
			id: '11',
			position: { x: 250, y:700 },
			data: { label: 'Model Classification',route : '/model-classification-config'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
			}
		},
		{
			id: '12',
			position: { x: 750, y: 700 },
			data: { label: 'Model Classification',route : '/model-classification-config'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multi' ? 'gray' : '#1890ff'
			},
			sourcePosition: 'right' 
		},
		{
			id: '13',
			position: { x: 250, y: 800 },
			data: { label: 'Filter Type', route : '/filter-type'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
			}
		},
		{
			id: '14',
			position: { x: 250, y: 900 },
			data: { label: 'Data Generation',route : '/data-generation'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
			}
		},
		{
			id: '15',
			position: { x: 250, y: 300 },
			data: { label: 'Data Source', name : data?.datasource, route : '/datasource'},
			draggable: false,
			style: {
				...baseNodeStyle,
				// backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
			},
			type : 'hoverNode'
		},
		{
			id: '16',
			position: { x: 250, y: 1000 },
			data: { label: 'Multiple Model',route : '/multiplemodels'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
			}
		},		
		{
			id: '19',
			position: { x: 1250, y: predy },
			data: { label: 'Prediction'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multi' ? 'gray' : '#1890ff'
			}
		},		
		{
			id: '20',
			position: { x: -750, y: predy },
			data: { label: 'Prediction'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'single' ? 'gray' : '#1890ff'
			}
		},
		{
				
			id: '21',
			position: { x: 250, y: predy },
			data: { label: 'Main Prediction'},
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
			}
		},		
		{
			id: '22',
			position: { x: 250, y: 1900 },
			data: { label: 'Event Types',route : '/multiplemodels'},
			draggable: false,
			style: {
				...baseNodeStyle,
				
			}
		},		
		{
			id: '23',
			position: { x: 250, y: 2000 },
			data: { label: 'Event',route : '/multiplemodels'},
			draggable: false,
			style: {
				...baseNodeStyle,			
			}
		},		
		{
			id: '26',
			position: { x: 250, y: 2100 },
			data: { label: 'Event Validator',route : '/imageclassificationconfiguration'},
			draggable: false,
			style: {
				...baseNodeStyle,
			}
		},
		{
			id: '24',
			position: { x: 250, y: 2200 },
			data: { label: 'Alarm Rule Engine',route : '/multiplemodels'},
			draggable: false,
			style: {
				...baseNodeStyle,
			}
		},
		{
			id: '25',
			position: { x: 250, y: 2300 },
			data: { label: 'Alarm ',route : '/multiplemodels'},
			draggable: false,
			style: {
				...baseNodeStyle,
			}
		},
		
		

				
				
	];



	const edges = [
		{ id: '1-2', source: '1', target: '2' },  // Pipeline → Region
		{ id: '2-3', source: '2', target: '3' },  // Region → PIDS
		{ id: '3-4', source: '3', target: '4' },  // PIDS → Channel
		{ id: '4-5', source: '4', target: '5' },  // Channel → Model Type
		{ id: '5-6', source: '5', target: '6' },  // Model Type → Prediction Level

		{ id: '6-7', source: '6', target: '7' },  // Prediction Level → Single Mode
		{ id: '6-8', source: '6', target: '8' },  // Prediction Level → Multiple Mode
		{ id: '6-9', source: '6', target: '9' },  // Prediction Level → Multi Mode

		{ id: '7-10', source: '7', target: '10' }, // Single Mode → Model Classification (Single)
		{ id: '8-11', source: '8', target: '11' }, // Multiple Mode → Model Classification (Multiple)
		{ id: '9-12', source: '9', target: '12' }, // Multi Mode → Model Classification (Multi)

		{ id: '11-13', source: '11', target: '13' }, // Model Classification (Multiple) → Filter Type
		{ id: '13-14', source: '13', target: '14' }, // Filter Type → Data Generation
		{ id: '14-16', source: '14', target: '16' }, // Data Generation → Multiple Model

		// { id: '20-22', source: '20', target: '22' }, // Prediction (Single) → Event
		// { id: '19-22', source: '19', target: '22' }, // Prediction (Multi) → Event

		{ id: '21-22', source: '21', target: '22' }, // Prediction (Multiple) → Event

		{ id: '14-15', source: '14', target: '15' }, // Data Generation → Data Source
		{ id: '14-15', source: '14', target: '15' }, // Data Generation → Data Source (duplicate edge)
		{ id: '15-5', source: '15', target: '5' },   // Data Source → Model Type (feedback loop)

		{ id: '24-25', source: '24', target: '25' }, // Alarm rule engine → alarm
		{ id: '22-23', source: '22', target: '23' }, // Event Types  → Event
		

		{ id: '23-26', source: '23', target: '26' }, // Event → Image Classification
		// { id: '26-25', source: '26', target: '25' }, // Image Classification → Alarm
	];

	let updatedNodes = [...nodes];
	let updatedEdges = [...edges];

	

	if(data?.single.length > 0){
		const items = data?.multiple?.[0];
		
		// to calculate horizontal spacing
		const subChains = data.multiple[0].filter(i => i.isSubChain === true);
		const numberOfSubchains = subChains.length;
		const total = items?.length - numberOfSubchains + 1;	
		
		const nodeStyle = {
			...baseNodeStyle,
			backgroundColor : data?.multimod != 'single' ? 'gray' : '#1890ff'
		};

		updatedNodes.push({
			id: '17',
			position: {
				x: total ? -(total)*250 : -750 ,
				y: 700
			},
			data: { 
				label: data?.single[0][0].modelname,	
				route : '/model-classification-config'			
			},
			draggable: false,
			style: nodeStyle,
			type: 'hoverNode',
		});

		updatedEdges.push({
			id: '10-17',
			source: '10',
			target: '17'
		});
		updatedEdges.push({
			id: '17-20',
			source: '17',
			target: '20'
		});
	}

	if(data?.multi.length > 0){	
		const items = data?.multiple?.[0];

		// to calculate horizontal spacing
		const subChains = data.multiple[0].filter(i => i.isSubChain === true);
		const numberOfSubchains = subChains.length;
		const total = items?.length - numberOfSubchains + 1;

		const nodeStyle = {
			...baseNodeStyle,
			backgroundColor : data?.multimod != 'multi' ? 'gray' : '#1890ff'
		};
		updatedNodes.push({
			id: '18',
			position: {
				x:  total ? ((total+ 2)*250) : 1250,
				y: 700
			},
			data: { 
				label: data?.multi[0][0].modelname,				
				model: data?.multi[0][0].model,		
				route : '/model-classification-config'		
			},
			draggable: false,
			style: nodeStyle,
			type: 'hoverNode',
		});

		updatedEdges.push({
			id: '12-17',
			source: '12',
			target: '18'
		});
	}
	if(data?.multi.length > 0){	
		const item = data?.multiple?.[0];

		const subChains = data.multiple[0].filter(i => i.isSubChain === true);
		const numberOfSubchains = subChains.length;
		const totals = item?.length - numberOfSubchains + 1;
		
		const baseX = totals ? (totals+2)*250 : 1250;    
		const baseY = 800;   
		const spacing = 300;  
		const items = data?.multi[0][0].subclass;
		const total = items.length;

		data.multi[0][0].subclass.forEach((item, index) => {

			const newNodeId = `multi-${index}`;

			const startX = baseX - ((total - 1) * spacing) / 2;
			const nodeStyle = {
				...baseNodeStyle,
				backgroundColor : data?.multimod != 'multi' ? 'gray' : '#1890ff'
			};

			updatedNodes.push({
				id: newNodeId,
				position: {
					x: startX + index * spacing,
					y: baseY
				},
				data: { 
					label: item,
					model : data?.multi[0][0].model,
					route : '/model-classification-config'	
					
				},
				draggable: false,
				style: nodeStyle,
				type: 'hoverNode',
			});

			// edges from above node to newly created nodes
			updatedEdges.push({
				id: `18-${newNodeId}`,
				source: '18',
				target: newNodeId
			});

			// edges from newly created nodes to below nodes
			updatedEdges.push({
				id: `${newNodeId}-19`,
				source: newNodeId,
				target: '19'
			});

		});
	}


	if (data?.multiple?.[0]?.length > 0) {
		const verticalHeight = 120;
		const baseX = 250;
		const baseY = 1200;
		const spacing = 300;

		const items = data.multiple[0];
		const subChains = data.multiple[0].filter(i => i.isSubChain === true);
		const numberOfSubchains = subChains.length;
		const subChainExists = items.some(item => item.isSubChain === true);
		const total = items.length - numberOfSubchains;

		let maxY = 0;
		

		//  max filters array
		const maxFilters = Math.max(
			...items.map(item => (item.filters ? item.filters.length : 0))
		);

		// max filter length (for layout height)
		let maxSubchainFilters = 0;
		if(subChains.length > 0){
			maxSubchainFilters = Math.max(
				...subChains.map(i => (i.filters ? i.filters.length : 0))
			);
		}
		let subChainHeight = 0;
		subChainHeight = (maxSubchainFilters + 5) * 120;


		
		items.forEach((item, index) => {
			maxY = 1200;

			const parentNodeId = `multiple-${index}`;
			const startX = baseX - ((total - 1) * spacing) / 2;
			const nodeX = startX + index * spacing;

			const verticalSpacing = 120;
			let currentLevel = 0;

			// parent node (chain name)
			if(item.isSubChain !== true){

				updatedNodes.push({ 
					id: parentNodeId,
					position: { x: nodeX, y: baseY },
					data: { label: item.name, isSubChain : item.isSubChain, mainClass : item.mainClass, modeltype : item.modeltype, modelClass: item.modelclass ? item.modelclass.join(', ') : 'N/A',
						chainType : 'Main Chain',
						route : '/multiplemodels'
					},
					
					draggable: false,
					style: {...baseNodeStyle,
						backgroundColor: data?.multimod == 'multiple' ? item?.status == true && item.isSubChain == true ? 'green' : item.status == true ? '#1890ff' : 'gray':'gray'
					},
					type : 'hoverNode'
				});
			}
			

			updatedEdges.push({
				id: `16-${parentNodeId}`,
				source: '16',
				target: parentNodeId
			});

			let previousNodeId = parentNodeId;

			// filter nodes 

			const filters = item.filters || [];

			filters.forEach((filterItem, filterIndex) => {

				currentLevel++;

				const filterNodeId = `${parentNodeId}-filter-${filterIndex}`;
				if(item.isSubChain !== true){
					updatedNodes.push({
						id: filterNodeId,
						position: {
							x: nodeX,
							y: baseY + (currentLevel * verticalSpacing)
						},
						data: { label: filterItem ? filterItem : 'No filter',
							route : '/filter-type'
						},
						draggable: false,
						style: {
							...baseNodeStyle,
							backgroundColor: data?.multimod == 'multiple'?  item.status == true ? '#ffa837' : 'gray' : 'gray'
						},
						type : 'hoverNode'
					});
				}
				updatedEdges.push({
					id: `${previousNodeId}-${filterNodeId}`,
					source: previousNodeId,
					target: filterNodeId
				});

				previousNodeId = filterNodeId;
			});

			for(let i = 0; i < maxFilters; i++){
				maxY += verticalSpacing;
			}

			// invisible placeholders if filters < maxFilters
			for (let i = filters.length; i < maxFilters; i++) {
				currentLevel++;	
				const emptyNodeId = `${parentNodeId}-empty-${i}`;
				if(item.isSubChain !== true){
					updatedNodes.push({
						id: emptyNodeId,
						position: {
							x: nodeX,
							y: baseY + (currentLevel * verticalSpacing)
						},
						data: { label: '' },
						draggable: false,
						style: {
							opacity: 0,   // invisible
							border: 'none'
						}
					});
				}

			
			}

		
			// data generation name

			currentLevel++;
			const modelNodeId = `${parentNodeId}-model`;
			if(item.isSubChain !== true){
				updatedNodes.push({
					id: modelNodeId,
					position: {
						x: nodeX,
						y: baseY + (currentLevel * verticalSpacing)
					},
					data: {
						label: item.datageneration_name || 'N/A',
						route : '/data-generation'
					},
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod == 'multiple' ? item.status == true ? '#9900ff' : 'gray' : 'gray'
					
					},
					type: 'hoverNode'
				});
			}

			updatedEdges.push({
				id: `${previousNodeId}-${modelNodeId}`,
				source: previousNodeId,
				target: modelNodeId
			});


			// model name

			currentLevel++;
			const modelNameNodeId = `${parentNodeId}-modelName`;
			if(item.isSubChain !== true){
				updatedNodes.push({
					id: modelNameNodeId,
					position: {
						x: nodeX,
						y: baseY + (currentLevel * verticalSpacing)
					},
					data: {
						label: item.modelname || 'N/A',
						route : '/model-classification-config'
					},
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod == 'multiple' ? item.status == true ? '#0054a6' : 'gray' : 'gray'
					},
					type: 'hoverNode'
				});
			}

			updatedEdges.push({
				id: `${modelNodeId}-${modelNameNodeId}`,
				source: modelNodeId,
				target: modelNameNodeId
			});
			
			updatedEdges.push({
				id: `${modelNameNodeId}-29`,
				source: modelNameNodeId,
				target: '29'
			},{
				id: '29-21',
				source: '29',
				target: '21'
			});

			if(subChainExists){
				
				updatedEdges.push(
					{
						id : '20-27',
						source : '20',
						target : '27',
					},
					{
						id : '19-27',
						source : '19',
						target : '27'
					}
				);
			}else{
				updatedEdges.push(
					{ id: '20-22', source: '20', target: '22' }, // Prediction (Single) → Event
					{ id: '19-22', source: '19', target: '22' }, // Prediction (Multi) → Event
				);
			}


			if(item.isSubChain === true){

				let eventLevel = 0;
				const eventParent = `event-${index}`;
				let eventPrev = eventParent;

				const verticalSpacing = 120;
				const horizontalSpacing = 300;

				// EVENT NODE Y
				const eventNodeY = maxY + 720;

				// SUBCHAIN START Y (below Event)
				const eventBaseY = eventNodeY + verticalSpacing;

				// GET ONLY SUBCHAINS
				const subChains = data.multiple[0].filter(i => i.isSubChain === true);

				const subChainIndex = subChains.findIndex(sc => sc === item);
				const totalSubChains = subChains.length;

				// CENTER UNDER EVENT (X=250)
				const startX = 250 - ((totalSubChains - 1) * horizontalSpacing) / 2;
				const subchainX = startX + subChainIndex * horizontalSpacing;

				// MAX FILTER LENGTH (for layout height)
				const maxSubchainFilters = Math.max(
					...subChains.map(i => (i.filters ? i.filters.length : 0))
				);

				subChainHeight = (maxSubchainFilters + 2) * verticalSpacing;

				

				// SUBCHAIN PARENT NODE
				updatedNodes.push({
					id: eventParent,
					position: { x: subchainX, y: eventBaseY },
					data: { label: item.name, route: '/multiplemodels' , chainType : 'Sub Chain', subChainActivity : item.mainClass, modelClass: item.modelclass ? item.modelclass.join(', ') : 'N/A',},
					draggable: false,
					style: {...baseNodeStyle,
						backgroundColor: data?.multimod == 'multiple' ? item?.status == true && item.isSubChain == true ? 'green' : item.status == true ? '#1890ff' : 'gray':'gray'
					},
					type: 'hoverNode'
				});

				updatedEdges.push({
					id: `21-${eventParent}`,
					source: '21',
					target: eventParent
				});

				const eventFilters = item.filters || [];

				// FILTERS
				eventFilters.forEach((filterItem, fIndex) => {

					eventLevel++;

					const filterNode = `${eventParent}-filter-${fIndex}`;

					updatedNodes.push({
						id: filterNode,
						position: {
							x: subchainX,
							y: eventBaseY + eventLevel * verticalSpacing
						},
						data: { label: filterItem || 'No filter', route: '/filter-type' },
						draggable: false,
						style: {
							...baseNodeStyle,
							backgroundColor: data?.multimod == 'multiple'?  item.status == true ? '#ffa837' : 'gray' : 'gray'
						},
						type: 'hoverNode'
					});

					updatedEdges.push({
						id: `${eventPrev}-${filterNode}`,
						source: eventPrev,
						target: filterNode
					});

					eventPrev = filterNode;
				});

				// DATA GENERATION
				eventLevel++;

				const eventDataGen = `${eventParent}-datagen`;

				updatedNodes.push({
					id: eventDataGen,
					position: {
						x: subchainX,
						y: eventBaseY + eventLevel * verticalSpacing
					},
					data: { label: item.datageneration_name || 'N/A', route: '/data-generation' },
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod == 'multiple' ? item.status == true ? '#9900ff' : 'gray' : 'gray'
					
					},
					type: 'hoverNode'
				});

				updatedEdges.push({
					id: `${eventPrev}-${eventDataGen}`,
					source: eventPrev,
					target: eventDataGen
				});

				eventPrev = eventDataGen;

				// MODEL NAME
				eventLevel++;

				const eventModel = `${eventParent}-model`;

				updatedNodes.push({
					id: eventModel,
					position: {
						x: subchainX,
						y: eventBaseY + eventLevel * verticalSpacing
					},
					data: { label: item.modelname || 'N/A', route: '/model-classification-config' },
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod == 'multiple' ? item.status == true ? '#0054a6' : 'gray' : 'gray'
					},
					type: 'hoverNode'
				});

				updatedEdges.push({
					id: `${eventPrev}-${eventModel}`,
					source: eventPrev,
					target: eventModel
				});
				updatedEdges.push({
					id: `${eventModel}-28`,
					source: eventModel,
					target: '28'
				});
			}

		});


		const updatedmaxY = maxY + 720;

		updatedNodes.push({
					
			id: '28',
			position: { x: 250, y: updatedmaxY + subChainHeight + 360  },
			data: { label: 'Chain Selector',route : '/chainselector'},
			draggable: false,
			style: {
				...baseNodeStyle,
			}
				
		});
		// if updatedmaxy subchain exists
		if(updatedmaxY){
			updatedNodes.push(
				{
					id: '19',
					position: { x: (total+3)*250, y: subChainExists ?  updatedmaxY + subChainHeight + (verticalHeight *4) :  updatedmaxY + verticalHeight},
					data: { label: 'Prediction'},
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod != 'multi' ? 'gray' : '#1890ff'
					}
				},		
				{
					id: '20',
					position: { x: -(total+1)*250, y: subChainExists ?  updatedmaxY + subChainHeight + (verticalHeight *4) :  updatedmaxY + verticalHeight },
					data: { label: 'Prediction'},
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod != 'single' ? 'gray' : '#1890ff'
					}
				},	
				{
					id: '21',
					position: { x: 250, y: updatedmaxY    },
					data: { label: 'Main Prediction'},
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
					}
				},
				{
					id: '29',
					position: { x: 250, y: updatedmaxY - 120  },
					data: { label: 'Chain Selector',route : '/chainselector'},
					draggable: false,
					style: {
						...baseNodeStyle,
						backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
					}
				},
				{
					id: '22',
					position: { x: 250, y: subChainExists ? updatedmaxY+ subChainHeight + (verticalHeight*5) : updatedmaxY + (verticalHeight*5) },
					data: { label: 'Event Types',route : '/eventtypes'},
					draggable: false,
					style: {
						...baseNodeStyle,
				
					}
				},
				{
					id: '23',
					position: { x: 250, y: subChainExists ? updatedmaxY + subChainHeight + (verticalHeight*6) : updatedmaxY + (verticalHeight*6) },
					data: { label: 'Event',route : '/realtime-events'},
					draggable: false,
					style: {
						...baseNodeStyle,
				
					}
				},		
				{
					id: '26',
					position: { x: 250, y: subChainExists ? updatedmaxY + subChainHeight + (verticalHeight*7) : updatedmaxY + (verticalHeight*7) },
					data: { label: 'Event Validator',route : '/imageclassificationconfiguration'},
					draggable: false,
					style: {
						...baseNodeStyle,
				
					}
				},		
				{
					id: '24',
					position: { x: 250, y: subChainExists ?  updatedmaxY + subChainHeight + (verticalHeight*9) : updatedmaxY + (verticalHeight*9) },
					data: { label: 'Alarm Rule Engine',route : '/alarmrule'},
					draggable: false,
					style: {
						...baseNodeStyle,
				
					}
				},		
				{
					id: '25',
					position: { x: 250, y: subChainExists ? updatedmaxY + subChainHeight + (verticalHeight*10) : updatedmaxY + (verticalHeight*10) },
					data: { label: 'Alarm',route : '/realtime-alarm'},
					draggable: false,
					style: {
						...baseNodeStyle,
					}
				},
				{
					id: '27',
					position: { x: 250, y: subChainExists ? updatedmaxY + subChainHeight + (verticalHeight*4) : updatedmaxY + (verticalHeight*4) },
					data: { label: 'Prediction'},
					draggable: false,
					style: {
						...baseNodeStyle,
					}
				},
				
			);


			const totalImg = data?.imageclassification?.length || 0;
			const baseImgY = subChainExists
				? updatedmaxY + subChainHeight + (verticalHeight * 7)
				: updatedmaxY + (verticalHeight * 7);

			if (data?.imageclassification.length > 0) {

				// calculate once
				const maxFilterLength = Math.max(
					0,
					...data.imageclassification.map(i => i.filters?.length || 0)
				);

				// SAME LEVEL FOR DATA GENERATION FOR ALL COLUMNS
				const dataGenerationY = baseImgY + (verticalHeight * (maxFilterLength + 2));

				data.imageclassification.map((item, index) => {

					const parentNodeId = `eventvalidator-${index}`;
					const startX = 250 - ((totalImg - 1) * spacing) / 2;
					const nodeX = startX + index * spacing;

					// PARENT NODE
					updatedNodes.push({
						id: parentNodeId,
						position: { x: nodeX, y: baseImgY + verticalHeight },
						data: {
							chainType : 'EventValidator Chain',
							label: item.name,
							eventTypes: item.eventTypes.join(', '),
							modelClass: item.modelclass ? item.modelclass.join(', ') : 'N/A',
							timeTolerance: item.timeTolerance,
							eventPositionTolerance: item.eventPositionTolerance,
							eventConfidenceThreshold: item.eventConfidenceThreshold,
							eventWidthThreshold: item.eventWidthThreshold,
							durationThreshold: item.durationThreshold,
							route: '/imageclassificationconfiguration'
						},
						draggable: false,
						style: {
							...baseNodeStyle,
							backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#1890ff'
							: 'grey'
						: 'grey'
						},
						type: 'hoverNode'
					});

					let previousNodeId = parentNodeId;
					const imgFilters = item.filters || [];

					// FILTER NODES
					imgFilters.forEach((filterItem, filterIndex) => {

						const filterNodeId = `filterImg-${index}-${filterIndex}`;

						updatedNodes.push({
							id: filterNodeId,
							position: {
								x: nodeX,
								y: baseImgY + (verticalHeight * (filterIndex + 2))
							},
							data: { label: filterItem ? filterItem : 'No filter' },
							route: '/filter-type',
							draggable: false,
							style: {
								...baseNodeStyle,
								backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#ffa837'
							: 'grey'
						: 'grey'
							},
							
							type: 'hoverNode'
						});

						updatedEdges.push({
							id: `${previousNodeId}-${filterNodeId}`,
							source: previousNodeId,
							target: filterNodeId
						});
						updatedEdges.push({
							id: `26-${parentNodeId}`,
							source: '26',
							target: parentNodeId
						});

						

						previousNodeId = filterNodeId;
					});

					// INVISIBLE PLACEHOLDER NODES
					for (let i = imgFilters.length; i < maxFilterLength; i++) {

						const emptyNodeId = `${parentNodeId}-emptyImg-${i}`;

						updatedNodes.push({
							id: emptyNodeId,
							position: {
								x: nodeX,
								y: baseImgY + (verticalHeight * (i + 2))
							},
							data: { label: '' },
							draggable: false,
							style: {
								opacity: 0,
								border: 'none'
							}
						});
					}

					// DATA GENERATION NODE (aligned across columns)
					const modelNodeId = `${parentNodeId}-model`;

					updatedNodes.push({
						id: modelNodeId,
						position: {
							x: nodeX,
							y: dataGenerationY
						},
						data: {
							label: item.datageneration_name || 'N/A',
							route: '/data-generation'
						},
						draggable: false,
						style: {
							...baseNodeStyle,
							backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#9900ff'
							: 'grey'
						: 'grey'
						},
						
						type: 'hoverNode'
					});

					updatedEdges.push({
						id: `${previousNodeId}-${modelNodeId}`,
						source: previousNodeId,
						target: modelNodeId
					});

					// MODEL NAME NODE
					const modelNameNodeId = `${parentNodeId}-modelName`;

					updatedNodes.push({
						id: modelNameNodeId,
						position: {
							x: nodeX,
							y: dataGenerationY + verticalHeight
						},
						data: {
							label: item.modelclassname || 'N/A',
							route: '/model-classification-config'
						},
						draggable: false,
						style: {
							...baseNodeStyle,
							backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#0054a6'
							: 'grey'
						: 'grey'
						},
						
						type: 'hoverNode'
					});

					updatedEdges.push({
						id: `${modelNodeId}-${modelNameNodeId}`,
						source: modelNodeId,
						target: modelNameNodeId
					});

					updatedEdges.push({
						id: `${modelNameNodeId}-24`,
						source: modelNameNodeId,
						target: '24'
					});

				});

				// FINAL NODES (only once)
				updatedNodes.push(
					{
						id: '24',
						position: { x: 250, y: dataGenerationY + verticalHeight * 3 },
						data: { label: 'Alarm Rule Engine', route: '/alarmrule' },
						draggable: false,
						style: { ...baseNodeStyle }
					},
					{
						id: '25',
						position: { x: 250, y: dataGenerationY + verticalHeight * 4 },
						data: { label: 'Alarm', route: '/realtime-alarm' },
						draggable: false,
						style: { ...baseNodeStyle }
					}
				);

			}
			else{
				updatedEdges.push({
					id: '26-24',
					source: '26',
					target: '24'
				});
			}
		}
		
		// if not updatedmaxy 
		else{
			updatedNodes.push({
				
				id: '21',
				position: { x: 250, y: 1800 },
				data: { label: 'Prediction'},
				draggable: false,
				style: {
					...baseNodeStyle,
					backgroundColor : data?.multimod != 'multiple' ? 'gray' : '#1890ff'
				}
			},		
			{
				id: '22',
				position: { x: 250, y: 1900 },
				data: { label: 'Event Types',route : '/eventtypes'},
				draggable: false,
				style: {
					...baseNodeStyle,
				
				}
			},		
			{
				id: '23',
				position: { x: 250, y: 1900 },
				data: { label: 'Event',route : '/realtime-events'},
				draggable: false,
				style: {
					...baseNodeStyle,
				
				}
			},		
			{
				id: '26',
				position: { x: 250, y: 2000 },
				data: { label: 'Event Validator',route : '/imageclassificationconfiguration'},
				draggable: false,
				style: {
					...baseNodeStyle,
				
				}
			},		
			{
				id: '24',
				position: { x: 250, y: 2240 },
				data: { label: 'Alarm Rule Engine',route : '/alarmrule'},
				draggable: false,
				style: {
					...baseNodeStyle,
				
				}
			},		
			{
				id: '25',
				position: { x: 250, y: 2360 },
				data: { label: 'Alarm',route : '/realtime-alarm'},
				draggable: false,
				style: {
					...baseNodeStyle,
				}
			},
			);

			const totalImg = data?.imageclassification?.length || 0;
			if(data?.imageclassification.length > 0){
				

				// calculate once
				const maxFilterLength = Math.max(
					0,
					...data.imageclassification.map(i => i.filters?.length || 0)
				);

				//  SAME LEVEL FOR DATA GENERATION FOR ALL COLUMNS
				const dataGenerationY = 2000 + (verticalHeight * (maxFilterLength + 2));

				data.imageclassification.map((item, index) => {

					const parentNodeId = `eventvalidator-${index}`;
					const startX = 250 - ((totalImg - 1) * spacing) / 2;
					const nodeX = startX + index * spacing;

					// PARENT NODE
					updatedNodes.push({
						id: parentNodeId,
						position: { x: nodeX, y: 2000 + verticalHeight },
						data: {
							chainType : 'EventValidator Chain',
							label: item.name,
							eventTypes: item.eventTypes.join(', '),
							modelClass: item.modelclass ? item.modelclass.join(', ') : 'N/A',
							timeTolerance: item.timeTolerance,
							eventPositionTolerance: item.eventPositionTolerance,
							eventConfidenceThreshold: item.eventConfidenceThreshold,
							eventWidthThreshold: item.eventWidthThreshold,
							durationThreshold: item.durationThreshold,
							route: '/imageclassificationconfiguration'
						},
						draggable: false,
						style: {
							...baseNodeStyle,
							backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#1890ff'
							: 'grey'
						: 'grey'
						},
						type: 'hoverNode'
					});

					let previousNodeId = parentNodeId;
					const imgFilters = item.filters || [];

					// FILTER NODES
					imgFilters.forEach((filterItem, filterIndex) => {

						const filterNodeId = `filterImg-${index}-${filterIndex}`;

						updatedNodes.push({
							id: filterNodeId,
							position: {
								x: nodeX,
								y: 2000 + (verticalHeight * (filterIndex + 2))
							},
							data: { label: filterItem ? filterItem : 'No filter' },
							route: '/filter-type',
							draggable: false,
							style: {
								...baseNodeStyle,
								backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#ffa837'
							: 'grey'
						: 'grey'
							},
							type: 'hoverNode'
						});

						updatedEdges.push({
							id: `${previousNodeId}-${filterNodeId}`,
							source: previousNodeId,
							target: filterNodeId
						});

						updatedEdges.push({
							id: `26-${parentNodeId}`,
							source: '26',
							target: parentNodeId
						});

						previousNodeId = filterNodeId;
					});

					// INVISIBLE PLACEHOLDER NODES
					for (let i = imgFilters.length; i < maxFilterLength; i++) {

						const emptyNodeId = `${parentNodeId}-emptyImg-${i}`;

						updatedNodes.push({
							id: emptyNodeId,
							position: {
								x: nodeX,
								y: 2000 + (verticalHeight * (i + 2))
							},
							data: { label: '' },
							draggable: false,
							style: {
								opacity: 0,
								border: 'none'
							}
						});
					}

					// DATA GENERATION NODE (aligned across columns)
					const modelNodeId = `${parentNodeId}-model`;

					updatedNodes.push({
						id: modelNodeId,
						position: {
							x: nodeX,
							y: dataGenerationY
						},
						data: {
							label: item.datageneration_name || 'N/A',
							route: '/data-generation'
						},
						draggable: false,

						style: {
							...baseNodeStyle,
							backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#9900ff'
							: 'grey'
						: 'grey'
						},
						
						
						type: 'hoverNode'
					});

					updatedEdges.push({
						id: `${previousNodeId}-${modelNodeId}`,
						source: previousNodeId,
						target: modelNodeId
					});

					// MODEL NAME NODE
					const modelNameNodeId = `${parentNodeId}-modelName`;

					updatedNodes.push({
						id: modelNameNodeId,
						position: {
							x: nodeX,
							y: dataGenerationY + verticalHeight
						},
						data: {
							label: item.modelclassname || 'N/A',
							route: '/model-classification-config'
						},
						draggable: false,

						style: {
							...baseNodeStyle,
							backgroundColor:
					data?.imageclassificationenabled === 'true'
						? item?.isEnabled == true
							? '#0054a6'
							: 'grey'
						: 'grey'
						},
						type: 'hoverNode'
					});

					updatedEdges.push({
						id: `${modelNodeId}-${modelNameNodeId}`,
						source: modelNodeId,
						target: modelNameNodeId
					});

					updatedEdges.push({
						id: `${modelNameNodeId}-24`,
						source: modelNameNodeId,
						target: '24'
					});

				});

				// FINAL NODES (only once)
				updatedNodes.push(
					{
						id: '24',
						position: { x: 250, y: dataGenerationY + verticalHeight * 3 },
						data: { label: 'Alarm Rule Engine', route: '/alarmrule' },
						draggable: false,
						style: { ...baseNodeStyle }
					},
					{
						id: '25',
						position: { x: 250, y: dataGenerationY + verticalHeight * 3 },
						data: { label: 'Alarm', route: '/realtime-alarm' },
						draggable: false,
						style: { ...baseNodeStyle }
					}
				);

			}
			
			else{
				updatedEdges.push({
					id: '26-24',
					source: '26',
					target: '24'
				});
			}
		}
	} 
	// if no chains in multiple mode
	else {

		const noModelNodeId = 'multiple-nodata';

		updatedNodes.push({
			id: noModelNodeId,
			position: { x: 250, y: 1200 },
			data: { label: 'NO CHAIN' },
			draggable: false,
			style: {
				...baseNodeStyle,
				backgroundColor: data?.multimod == 'multiple'? '#ff4d4f' : 'gray' // red for visibility
			},
			// type: 'hoverNode',
		},
		);

		// connect 16 -> NO MODELS
		updatedEdges.push({
			id: `16-${noModelNodeId}`,
			source: '16',
			target: noModelNodeId
		});

		// connect NO MODELS -> 21
		updatedEdges.push({
			id: `${noModelNodeId}-21`,
			source: noModelNodeId,
			target: '21'
		});

		updatedEdges.push({
			id : '19-22',
			source : '19',
			target : '22',

		},
		{
			id : '20-22',
			source :'20',
			target : '22',
		});
		
	}

	const HoverNode = ({ data }) => {
		return (
			<>
				{/* Target Handle (incoming edge) */}
				<Handle
					type="target"
					position={Position.Top}
				/>

				<Tooltip
					title={
						<div>

							{data?.label && (
								<div>
									<strong>Name:</strong> {data.label}
								</div>
							)}
							
							{data?.eventTypes && (
								<div>
									<strong>Event Types:</strong> {data.eventTypes}
								</div>
							)}
							{data?.modelClass && (
								<div>
									<strong>Model Class:</strong> {data.modelClass}
								</div>
							)}
							{data?.timeTolerance && (
								<div>
									<strong>Time Tolerance:</strong> {data.timeTolerance}
								</div>
							)}
							{data?.eventPositionTolerance && (
								<div>
									<strong>Event Position Tolerance:</strong> {data.eventPositionTolerance}
								</div>
							)}
							{data?.eventConfidenceThreshold && (
								<div>
									<strong>Event Confidence Threshold:</strong> {data.eventConfidenceThreshold}
								</div>
							)}
							{data?.eventWidthThreshold && (
								<div>
									<strong>Event Width Threshold:</strong> {data.eventWidthThreshold}
								</div>
							)}
							{data?.subChainActivity && (
								<div>
									<strong>SubChain Activity:</strong> {data.subChainActivity}
								</div>
							)}
							{data?.durationThreshold && (
								<div>
									<strong>Duration Threshold:</strong> {data.durationThreshold}
								</div>
							)}
							{data?.name && (
								<div>
									<strong>Datasource:</strong> {data.name}
								</div>
							)}
							{data?.modeltype && (
								<div>
									<strong>Model Type:</strong> {data.modeltype}
								</div>
							)}
							{data?.pipeline && (
								<div>
									<strong>Pipeline:</strong> {data.pipeline}
								</div>
							)}
							{data?.channel && (
								<div>
									<strong>Channel:</strong> {data.channel}
								</div>
							)}
							{data?.region && (
								<div>
									<strong>Region:</strong> {data.region}
								</div>
							)}
							{data?.pidsname && (
								<div>
									<strong>PIDS:</strong> {data.pidsname}
								</div>
							)}
							{data?.chainType && (
								<div>
									<strong>Chain Type:</strong> {data.chainType}
								</div>
							)}

							{/* {typeof data?.isSubChain === 'boolean' && (
								<div>
									<strong>SubChain:</strong> {data.isSubChain ? 'Yes' : 'No'}
								</div>
							)} */}

							{data?.mainClass && (
								<div>
									<strong>Main Class:</strong> {data.mainClass}
								</div>
							)}

							{data?.model && (
								<div>
									<strong>Model:</strong> {data.model}
								</div>
							)}

							{data?.datageneration_name && (
								<div>
									<strong>Data Generation Name:</strong> {data.datageneration_name}
								</div>
							)}

						</div>
					}
					placement="top"
				>
					<div
						style={{
							textAlign: 'center',
							cursor: 'pointer',
						}}
					>
						{data.label.length > 25 ? data.label.slice(0,25) + '...' : data.label}
					</div>
				</Tooltip>

				{/* Source Handle (outgoing edge) */}
				<Handle
					type="source"
					position={Position.Bottom}
				/>
			</>
		);
	};
	
	const nodeTypes = { hoverNode: HoverNode };


	function TreeFlow() {
		return (

			<div style={{ width: '100%', height: '800px' }}>
				<ReactFlow
					nodes={updatedNodes}
					edges={updatedEdges}
					nodesDraggable={false}
					nodesConnectable={false}
					elementsSelectable={false}
					nodeTypes={nodeTypes}
					onNodeClick={onNodeClick}
					fitView
					proOptions={{ hideAttribution: true }} 
					defaultEdgeOptions={{
						type: 'step',
						style: { stroke: '#000', strokeWidth: 2 }
					}}
				>
					<Background />
					<Controls position="top-right"
						style={{
							// background: '#0059ff',
							borderRadius: '12px',
							boxShadow: '0 4px 10px rgba(0,0,0,0.3)'
						}} />
				</ReactFlow>
			</div>
		);
	}

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());
	
	

	const handleSetregion = (e, options) =>{
		if(options === 'region') {
			setRegionId(e);
			localStorage.setItem(`${dashboardtype.toUpperCase()}_REPORT_REGION_ID`,e);
			setpidsFilter(null);
			setchannels(null);
		} else if(options === 'pids') {
			localStorage.setItem(`${dashboardtype.toUpperCase()}_REPORT_PIDS`,e);
			setpidsFilter(e);
			setchannels(null);
		}else if(options === 'channels'){
			localStorage.setItem(`${dashboardtype.toUpperCase()}_REPORT_CHANNEL_ID`,e);
			setchannels(e);
		}
	};


	return (
		<>
			<Content>
				{/* Header Section */}
				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems: 'center',
					}}
					justify="space-between"
					align="middle"
				>
					{/* Left Side: Icon + Title */}
					<Col>
						<Row align="middle">
							<Space>
								<ApartmentOutlined style={{ fontSize: '30px' }} />
							</Space>

							<Space>&nbsp;&nbsp;</Space>

							<Title level={4} style={{ margin: 0 }}>
								{langdata && langdata.Tree ? langdata.Tree : 'Tree'}
							</Title>
						</Row>
					</Col>

					{/* Right Side: Region Filter */}
					<Col>
						<Row align="middle">
							<Tooltip
								placement="bottom"
								title={
									langdata && langdata.Filterbyregion
										? langdata.Filterbyregion
										: 'Filter by region'
								}
							>
								<Select
									showSearch
									filterOption={filterOption}
									style={{
										minWidth: '240px',
										maxWidth: '240px',
										margin: '5px',
									}}
									placeholder={
										langdata && langdata.SelectRegion
											? langdata.SelectRegion
											: 'Select Region'
									}
									optionFilterProp="children"
									value={regionId}
									options={regions}
									onSelect={(e) => handleSetregion(e,'region')}
								/>
							</Tooltip>

							<Space>
								<Tooltip placement="bottom" title={langdata && langdata.Filterbypids ? langdata.Filterbypids :'Filter by pids'}>
																					
									<Space>
										<Select Item
											style={{ minWidth: '200px', margin:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
											optionFilterProp="children"
											value={pidsFilter}
											options={pidsfilter}
											
											onSelect={(e) => handleSetregion(e,'pids')}
																			
																					
										/>  
									</Space>
								</Tooltip>  
							</Space>
							<Space>
								<Tooltip placement="bottom" title={langdata && langdata.Filterbychannel ? langdata.Filterbychannel :'Filter by channel'}>
																					
									<Space>
										<Select Item
											style={{ minWidth: '200px', margin:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={
												langdata && langdata.SelectChannel
													? langdata.SelectChannel
													: 'Select Channel'
											}
											optionFilterProp="children"
											value={channelsdata}
											options={channels}
											disabled={pidsFilter==null}
											onSelect={(e) => handleSetregion(e,'channels')}
																			
																					
										/>  
									</Space>
								</Tooltip>  
							</Space>
						</Row>
					</Col>
				</Row>

				{/* Tree Section */}
				<Row
					style={{
						margin: '10px',
						background: '#FFFFFF',
						padding: '20px',
					}}
				>
					<Col span={24}>
						{
							regionId !=null && pidsFilter != null && channelsdata != null ?
								<TreeFlow />
								:
								<Empty
									image={Empty.PRESENTED_IMAGE_SIMPLE}
									description="Please select filters"
								/>
						}
					</Col>
				</Row>
			</Content>

			

			{/* <Spin spinning={data.loading} fullscreen /> */}
		</>
	);
}